import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Form } from '@weezevent/nacre';
import { Loader } from 'semantic-ui-react';
import Style from './event-selector.module.css';
import { stylizeEventOption } from '../../../../components/events/select-events/utils';
export function EventSelector({ onChange, events, loadingEvents, event, disabled = false }) {
    const { t } = useTranslation();

    const selectListEvents = React.useMemo(() => {
        if (events?.length > 0)
            return events.map(e => {
                return {
                    value: e.id,
                    key: e.id,
                    text: stylizeEventOption(e)
                };
            });
        return [];
    }, [events]);

    return (
        <Form.Field>
            <div className={Style['label-and-loading']}>
                <Form.Label>{t('ticket.widgets.filtered_widget.event_label')}</Form.Label>
                {loadingEvents && <Loader active></Loader>}
            </div>
            <div className={Style['select']}>
                <Select
                    useNew
                    disabled={loadingEvents || disabled}
                    options={selectListEvents}
                    onChange={onChange}
                    value={event?.id}
                    placeholder={loadingEvents ? t('ticket.widgets.filtered_widget.event_placeholder_loading') : t('ticket.widgets.filtered_widget.event_placeholder')}
                />
            </div>
        </Form.Field>
    );
}
